<template>
  <!-- 轮播图 -->
  <div>
  <div class="banner-css pc" style="min-height:400px;">
    <el-carousel
      height="924px"
      style="z-index: -1"
      class="pc"
      :interval='5000'
      v-if="carousel.length > 1"
      arrow="never"
    >
      <el-carousel-item
        v-for="(item, index) of carousel"
        :key="index"
        style="margin: 0 auto; text-align: center"
      >
        <img :src="item" alt="" style="width: 100%" />
      </el-carousel-item>
    </el-carousel>
    <div style="width: 100%" v-if="carousel.length === 1">
      <img
        :src="carousel[0]"
        alt=""
        style="width: 100%; vertical-align: middle"
      />
    </div>
  </div>
  <div class="banner-css mobile" style="min-height:2rem;margin-top:0.59rem;">
    <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" :duration="2000">
      <van-swipe-item v-for="(item, index) of Mcarousel" :key="index">
        <img :src="item" alt="" style="width:100%;vertical-align: middle;" :style="Mcarousel.length > 1?`height:2.5rem;`:''"/>
      </van-swipe-item>
    </van-swipe>
  </div>
  </div>
</template>
<style lang="scss">
.el-carousel__button {
    display: block;
    opacity: .48;
    width: 10px;
    height: 10px;
    background-color: #fff;
    border-radius: 50px;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: .3s;
}
.el-carousel__item.is-animating {
    -webkit-transition: -webkit-transform 1s ease-in-out;
    transition: -webkit-transform 1s ease-in-out;
    transition: transform 1s ease-in-out;
    transition: transform 1s ease-in-out,-webkit-transform 1s ease-in-out;
}
</style>
<script>
export default {
  name: "Banner",
  props: {
    carousel: {
      type: [Array, String],
      default: [],
    },
    Mcarousel: {
      type: [Array, String],
      default: [],
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/banner/index.vue